import { Box, Button, Grid, Typography } from '@mui/material';
import ProjectFilter from '../../../../../components/filters/ProjectFilter';
import AddTypeModal from './components/AddTypeModal';
import ProjectTypesTable from './components/ProjectTypesTable';
import { EMPTY_PAYLOAD } from './const';
import { useProjectTypeContext } from './useProjectTypesContext';

const ProjectTypes = () => {
  const { setAddTypeModal, payload, setPayload } = useProjectTypeContext();
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        padding: 2,
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
      }}
    >
      <Grid
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 2 }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
          }}
        >
          <Typography variant="h6">Project Deliverable Types</Typography>
          <ProjectFilter
            projectId={payload.id}
            handleChange={(id) => {
              if (id) {
                setPayload((prev) => ({ ...prev, id }));
              } else {
                setPayload(EMPTY_PAYLOAD);
              }
            }}
          />
        </Box>
        <Button
          variant="contained"
          size="small"
          onClick={() => setAddTypeModal(true)}
          sx={{ mb: 2, alignSelf: 'flex-end' }}
        >
          Add Type
        </Button>
      </Grid>
      <ProjectTypesTable />
      <AddTypeModal />
    </Box>
  );
};

export default ProjectTypes;
